import React from 'react';
import {Table, Button, Message, Modal, FormControl, Select} from 'tinper-bee';
import Layout from '../Layout';
import './index.css';
import * as util from '../../utils';

const STATUS_MAP: { [key: string]: string } = {
    pending: '待审核',
    approved: '已通过',
    rejected: '已拒绝',
};

const STATUS_COLOR: { [key: string]: string } = {
    pending: '#faad14',
    approved: '#52c41a',
    rejected: '#f5222d',
};

class ExperienceAudit extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            list: [],
            total: 0,
            pageNumber: 1,
            pageSize: 10,
            loading: false,
            auditLoading: false,
            rejectModalVisible: false,
            currentRow: null,
            rejectReason: '',
            queryStatus: 'pending',
            queryProjectType: '',
            queryKeyword: '',
            projectTypeMap: {},
            projectTypeList: [],
        };
    }

    componentDidMount() {
        if (!window.localStorage.user) {
            this.props.history.push('/skill-market');
            return;
        }
        this.loadProjectTypes();
        this.loadData();
    }

    loadProjectTypes = async () => {
        try {
            const result: any = await util.get('/yoncode/dict/list', { dict_type: 'project_type' });
            if (result.status === 200 && result.data && result.data.length > 0) {
                const raw = result.data[0].dict_value;
                const parsed: any[] = typeof raw === 'string' ? JSON.parse(raw) : raw;
                const map: { [key: string]: string } = {};
                parsed.forEach((item: any) => {
                    map[item.key] = item.label;
                });
                this.setState({ projectTypeMap: map, projectTypeList: parsed });
            }
        } catch (e) {
            // 忽略错误
        }
    };

    loadData = async (pageNumber = 1, queryStatus?: string, queryProjectType?: string, queryKeyword?: string) => {
        this.setState({ loading: true });
        try {
            const status = queryStatus !== undefined ? queryStatus : this.state.queryStatus;
            const projectType = queryProjectType !== undefined ? queryProjectType : this.state.queryProjectType;
            const keyword = queryKeyword !== undefined ? queryKeyword : this.state.queryKeyword;
            const params: any = {
                pageNumber,
                pageSize: this.state.pageSize,
            };
            if (status) {
                params.status = status;
            }
            if (projectType) {
                params.project_type = projectType;
            }
            if (keyword && keyword.trim()) {
                params.keyword = keyword.trim();
            }
            const result: any = await util.get('/yoncode/invite/list', params);
            if (result.status === 200) {
                this.setState({
                    list: result.data || [],
                    total: result.total || 0,
                    pageNumber,
                });
            }
        } catch (e) {
            Message.create({ content: '加载数据失败', color: 'danger' });
        } finally {
            this.setState({ loading: false });
        }
    };

    handlePageChange = (pageNumber: number) => {
        this.loadData(pageNumber, this.state.queryStatus, this.state.queryProjectType, this.state.queryKeyword);
    };

    handleStatusChange = (status: string) => {
        this.setState({ queryStatus: status, pageNumber: 1 });
        this.loadData(1, status, this.state.queryProjectType, this.state.queryKeyword);
    };

    handleProjectTypeChange = (projectType: string) => {
        this.setState({ queryProjectType: projectType, pageNumber: 1 });
        this.loadData(1, this.state.queryStatus, projectType, this.state.queryKeyword);
    };

    handleKeywordSearch = () => {
        this.setState({ pageNumber: 1 });
        this.loadData(1, this.state.queryStatus, this.state.queryProjectType, this.state.queryKeyword);
    };

    handleKeywordClear = () => {
        this.setState({ queryKeyword: '', pageNumber: 1 });
        this.loadData(1, this.state.queryStatus, this.state.queryProjectType, '');
    };

    handleKeywordKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            this.handleKeywordSearch();
        }
    };

    handleApprove = async (row: any) => {
        this.setState({ auditLoading: true });
        try {
            const result: any = await util.post('/yoncode/invite/audit', {
                id: row.id,
                status: 'approved',
            });
            if (result.status === 200) {
                Message.create({ content: '审核通过', color: 'success' });
                this.loadData(this.state.pageNumber);
            } else {
                Message.create({ content: result.message || '审核失败', color: 'danger' });
            }
        } catch (e) {
            Message.create({ content: '审核失败', color: 'danger' });
        } finally {
            this.setState({ auditLoading: false });
        }
    };

    handleReject = (row: any) => {
        this.setState({
            rejectModalVisible: true,
            currentRow: row,
            rejectReason: '',
        });
    };

    handleRejectConfirm = async () => {
        const { currentRow, rejectReason } = this.state;
        if (!rejectReason.trim()) {
            Message.create({ content: '请填写拒绝原因', color: 'warning' });
            return;
        }
        this.setState({ auditLoading: true });
        try {
            const result: any = await util.post('/yoncode/invite/audit', {
                id: currentRow.id,
                status: 'rejected',
                reject_reason: rejectReason,
            });
            if (result.status === 200) {
                Message.create({ content: '已拒绝', color: 'success' });
                this.setState({ rejectModalVisible: false });
                this.loadData(this.state.pageNumber);
            } else {
                Message.create({ content: result.message || '审核失败', color: 'danger' });
            }
        } catch (e) {
            Message.create({ content: '审核失败', color: 'danger' });
        } finally {
            this.setState({ auditLoading: false });
        }
    };

    render() {
        const { list, total, pageNumber, pageSize, loading, auditLoading, queryStatus, projectTypeMap, projectTypeList, queryProjectType, queryKeyword } = this.state;
        const { rejectModalVisible, rejectReason } = this.state;

        const statusTabs = [
            { label: '全部', value: '' },
            { label: '待审核', value: 'pending' },
            { label: '已通过', value: 'approved' },
            { label: '已拒绝', value: 'rejected' },
        ];

        const columns = [
            {
                title: '用户姓名',
                dataIndex: 'user_name',
                key: 'user_name',
                width: 120,
            },
            {
                title: '用户邮箱',
                dataIndex: 'email',
                key: 'email',
                width: 200,
            },
            {
                title: '项目类型',
                dataIndex: 'project_type',
                key: 'project_type',
                width: 150,
                render: (val: string) => projectTypeMap[val] || val,
            },
            // {
            //     title: '邀请码',
            //     dataIndex: 'invite_code',
            //     key: 'invite_code',
            // },
            {
                title: '创建时间',
                dataIndex: 'create_time',
                key: 'create_time',
                width: 180,
            },
            {
                title: '审核状态',
                dataIndex: 'status',
                key: 'status',
                width: 100,
                render: (val: string) => (
                    <span style={{ color: STATUS_COLOR[val] || '#666' }}>
                        {STATUS_MAP[val] || val}
                    </span>
                ),
            },
            {
                title: '操作',
                key: 'action',
                width: 160,
                render: (_: any, row: any) => {
                    if (row.status !== 'pending') {
                        return <span style={{ color: '#999' }}>—</span>;
                    }
                    return (
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Button
                                size="sm"
                                colors="primary"
                                loading={auditLoading}
                                onClick={() => this.handleApprove(row)}
                            >
                                通过
                            </Button>
                            <Button
                                size="sm"
                                colors="danger"
                                loading={auditLoading}
                                onClick={() => this.handleReject(row)}
                            >
                                拒绝
                            </Button>
                        </div>
                    );
                },
            },
        ];

        return (
            <div className="experience-audit-wrapper">
                <div className="audit-header">
                    <div className="audit-title">体验资格审核</div>
                </div>
                <div className="audit-status-tabs">
                    {statusTabs.map(tab => (
                        <span
                            key={tab.value}
                            className={`status-tab ${queryStatus === tab.value ? 'active' : ''}`}
                            onClick={() => this.handleStatusChange(tab.value)}
                        >
                            {tab.label}
                        </span>
                    ))}
                </div>
                <div className="audit-filter-row">
                    <div className="audit-filter-item">
                        <span className="filter-label">用户/手机号/邮箱：</span>
                        <FormControl
                            value={queryKeyword}
                            onChange={(val: any) => this.setState({ queryKeyword: val })}
                            onKeyDown={this.handleKeywordKeyDown}
                            placeholder="请输入用户、手机号或邮箱"
                        />
                    </div>
                    <div className="audit-filter-item">
                        <span className="filter-label">项目类型：</span>
                        <Select
                            value={queryProjectType}
                            onChange={(val: any) => this.handleProjectTypeChange(val)}
                        >
                            <Select.Option value="">全部</Select.Option>
                            {projectTypeList.map((item: any) => (
                                <Select.Option key={item.key} value={item.key}>
                                    {item.label}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <Button size="sm" colors="primary" onClick={this.handleKeywordSearch}>
                        查询
                    </Button>
                    <Button size="sm" onClick={this.handleKeywordClear}>
                        清空
                    </Button>
                </div>
                <div className="audit-content">
                    <Table
                        columns={columns}
                        data={list}
                        loading={loading}
                        emptyText={() => '暂无待审核数据'}
                    />
                    {total > pageSize && (
                        <div className="audit-pagination">
                            <Button
                                size="sm"
                                disabled={pageNumber <= 1}
                                onClick={() => this.handlePageChange(pageNumber - 1)}
                            >
                                上一页
                            </Button>
                            <span className="page-info">
                                第 {pageNumber} / {Math.ceil(total / pageSize)} 页
                            </span>
                            <Button
                                size="sm"
                                disabled={pageNumber >= Math.ceil(total / pageSize)}
                                onClick={() => this.handlePageChange(pageNumber + 1)}
                            >
                                下一页
                            </Button>
                        </div>
                    )}
                </div>

                <Modal
                    show={rejectModalVisible}
                    onHide={() => this.setState({ rejectModalVisible: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>拒绝原因</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormControl
                            componentClass="textarea"
                            rows={3}
                            value={rejectReason}
                            onChange={(e: any) => this.setState({ rejectReason: e })}
                            placeholder="请输入拒绝原因"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            onClick={() => this.setState({ rejectModalVisible: false })}
                        >
                            取消
                        </Button>
                        <Button
                            colors="danger"
                            loading={auditLoading}
                            onClick={this.handleRejectConfirm}
                        >
                            确认拒绝
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default Layout(ExperienceAudit, 'experience-audit-page');
